import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { AgGrid, filterParams, filters, gridConstants as gc } from "../AgGrid";
import { getOrdersColumnDefinitions } from "../../helpers";
import classnames from "classnames";

// SERVICES
import {
  getOrderActivityHistory,
  // getOrdersByStatusAndTerritory
} from "../../services";

const styles = theme => ({});

export const OrdersGridByStatus = withStyles(styles)(props => {
  const { classes, setPageTitle } = props;

  console.log(props)

  const [orderData, setOrderData] = useState([]);
  const [inspectors, setInspectors] = useState([]);
  // const [gridLabel, setGridLabel] = useState("Orders");
  // const [gridName, setGridName] = useState(null);
  const [queryParams, setQueryParams] = useState({});

  const columnDefinitions = getOrdersColumnDefinitions();

  useEffect(() => {
    // console.log(props);
    const qParams = props.location.search
      .slice(1) // remove the leading '?'
      .split("&") // split into key/value pairs
      .map(pair => pair.split("=")) // split each key/value pair into indexes
      .map(pair => {
        return {
          [pair[0]]: pair[1].replace(/%20/g, " ")
        };
      })
      .reduce((acc, cur) => Object.assign(acc, cur), {});

    setQueryParams(qParams);
    const { status, statusId, territoryBased } = qParams;

    setPageTitle(`Orders - ${status}`)
  }, []);

  const detailCellRendererParams = {
    detailGridOptions: {
      columnDefs: [
        { field: "histType" },
        { field: "serviceType.name" },
        { field: "serviceStatus.code" },
        {
          field: "histChangeDateTime",
          cellRenderer: params => {
            const d = new Date(params.value);
            return `${d.getMonth()}-${d.getDate()}-${d.getFullYear()}`;
          }
        }
      ],
      defaultColDef: {
        editable: false,
        resizable: true
      },
      onFirstDataRendered(params) {
        params.api.sizeColumnsToFit();
      }
    },
    getDetailRowData: async function(params) {
      const res = await getOrderActivityHistory(params.data.id);
      const latestObj = res.reduce((acc, cur) => {
        if (
          !acc[cur.histType] ||
          new Date(acc[cur.histType].histChangeDateTime) <
            new Date(cur.histChangeDateTime)
        ) {
          acc[cur.histType] = cur;
        }
        return acc;
      }, {});

      const latestArr = Object.values(latestObj);
      params.successCallback(latestArr);
    }
  };

  // const getOrdersByStatusAndTerritoryAsync = async (
  //   statusId,
  //   territoryBased
  // ) => {
  //   try {
  //     const rowData = await getOrdersByStatusAndTerritory(
  //       statusId,
  //       territoryBased
  //     );
  //     // console.log(rowData[0])
  //     setOrderData(rowData);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  return (
    <div className={classnames("flex-1", "col-center-center")}>
      {/* <h1 style={{ marginTop: 0 }}>{gridLabel}</h1> */}
      <AgGrid
        gridData={orderData}
        columnDefs={columnDefinitions}
        handleCellClick={evt =>
          (window.location = `${window.location.origin}/#/orders/${evt.data.orderTicket}`)
        }
        redirectOnClick={true}
        editOnClick={false}
        detailCellRendererParams={detailCellRendererParams}
        gridProps={{
          masterDetail: true
        }}
        useDatasource={true}
        datasourceUrl={"/orders"}
        gridName={queryParams.gridName}
      />
    </div>
  );
});
